module.exports = __webpack_public_path__ + "img/user-check.33597ea2.svg";